import * as React from 'react';
import { useSelector } from 'react-redux';
import './bannerComponent.scss';

function BannerComponent() {
  const bannerValues = useSelector((state) => state.runSeqReducer);
  return (
    <div className="row">
      <div className="col-lg-12 subBanner">
        <b>{bannerValues.pageDesc}</b>
      </div>
    </div>
  );
}

export default BannerComponent;
